module.exports = __webpack_public_path__ + "static/media/open-sans-v27-latin-regular.07f8c319.woff";